(function () {
  'use strict';

  // The store's real base currency is INR (every data-base-price attribute
  // holds a real INR amount — the visitor's market-adjusted price, already
  // correctly computed server-side by Shopify's Market Catalogs). This
  // picker is DISPLAY-ONLY: it converts that INR amount into whatever
  // currency the shopper picks, purely for their own reference. Checkout
  // always charges the real INR amount regardless of what's picked here.
  var RATES_PER_INR = {
    'INR': 1,
    'USD': 1 / 96.4,
    'GBP': 1 / 117.5,
    'EUR': 1 / 101.8,
    'CAD': 1 / 68.9,
    'AUD': 1 / 62.9,
    'AED': 1 / 26.25,
    'SGD': 1 / 74.7
  };

  var CURRENCY_INFO = {
    'USD': { symbol: '$', name: 'US Dollar' },
    'INR': { symbol: '₹', name: 'Indian Rupee' },
    'GBP': { symbol: '£', name: 'British Pound' },
    'EUR': { symbol: '€', name: 'Euro' },
    'CAD': { symbol: 'C$', name: 'Canadian Dollar' },
    'AUD': { symbol: 'A$', name: 'Australian Dollar' },
    'AED': { symbol: 'د.إ', name: 'UAE Dirham' },
    'SGD': { symbol: 'S$', name: 'Singapore Dollar' }
  };

  var currentCurrency = 'INR';

  function getVisitorCountry() {
    try {
      // Check URL path first to see if we are explicitly in the US or IN market
      var path = window.location.pathname;
      if (path.indexOf('/en-us') === 0 || path.includes('/en-us')) return 'US';
      if (path.indexOf('/en-in') === 0 || path.includes('/en-in')) return 'IN';

      var selectorComponent = document.querySelector('currency-selector-component');
      if (selectorComponent) {
        var country = selectorComponent.getAttribute('data-country');
        if (country) return country;
      }
      var countryElement = document.documentElement.getAttribute('data-country') ||
                          document.body.getAttribute('data-country');
      if (countryElement) return countryElement;
      var htmlLang = document.documentElement.lang;
      if (htmlLang && htmlLang.includes('en-IN')) return 'IN';
      if (htmlLang && htmlLang.includes('en-US')) return 'US';
    } catch (e) {}
    return 'IN'; // fallback to India
  }

  function getDefaultCurrencyForCountry(country) {
    if (country === 'IN') return 'INR';
    if (country === 'US') return 'USD';
    return 'USD';
  }

  // baseINR is always a real INR amount. Converts + formats as a whole
  // number, no decimals, for ANY currency (per explicit requirement: no
  // 123.23-style prices anywhere, in any currency).
  function formatFromINR(baseINR, currency) {
    var info = CURRENCY_INFO[currency] || CURRENCY_INFO['INR'];
    var rate = RATES_PER_INR[currency] != null ? RATES_PER_INR[currency] : 1;
    var converted = Math.round(baseINR * rate);
    return info.symbol + converted.toLocaleString('en-US');
  }

  function convertAllPrices() {
    document.querySelectorAll('[data-base-price]').forEach(function (el) {
      var baseINR = parseFloat(el.getAttribute('data-base-price'));
      if (isNaN(baseINR) || baseINR <= 0) return;
      el.textContent = formatFromINR(baseINR, currentCurrency);
    });

    document.querySelectorAll('.cpdp-price').forEach(function (el) {
      var basePaise = el.getAttribute('data-base-paise');
      if (basePaise) {
        var baseINR = parseFloat(basePaise) / 100;
        el.textContent = formatFromINR(baseINR, currentCurrency);
      }
    });
  }

  function updateTrigger() {
    var trigger = document.querySelector('.currency-selector__trigger');
    if (!trigger) return;
    var info = CURRENCY_INFO[currentCurrency] || CURRENCY_INFO['INR'];
    trigger.innerHTML =
      '<span class="cs__symbol">' + info.symbol + '</span>' +
      '<span class="cs__code">' + currentCurrency + '</span>' +
      '<svg class="cs__caret" width="10" height="10" viewBox="0 0 20 20" fill="none">' +
      '<path d="M5 8l5 5 5-5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
      '</svg>';
  }

  function updateOptions() {
    document.querySelectorAll('.currency-selector__option').forEach(function (opt) {
      var isActive = opt.dataset.currency === currentCurrency;
      opt.setAttribute('aria-selected', isActive);
      opt.classList.toggle('cs__option--active', isActive);
    });
  }

  function setCurrency(currency) {
    currentCurrency = currency;
    try { localStorage.setItem('selected_currency', currency); } catch (e) {}
    updateTrigger();
    updateOptions();
    convertAllPrices();

    // Dispatch custom event so that components like PDP calculators and variant selectors can react instantly
    document.dispatchEvent(new CustomEvent('currency-changed', {
      detail: { currency: currency }
    }));
  }

  // Currency defaults based on visitor location:
  // - India (IN): default INR
  // - USA (US): default USD
  // - Others: default USD
  // Respects manual override within session; resets per-market on new visit.
  function detectCurrency() {
    var visitorCountry = getVisitorCountry();
    var savedCurrency = null;
    try { savedCurrency = localStorage.getItem('selected_currency'); } catch (e) {}
    var savedCountry = null;
    try { savedCountry = localStorage.getItem('selected_currency_country'); } catch (e) {}

    if (savedCountry && savedCountry !== visitorCountry) {
      try {
        localStorage.removeItem('selected_currency');
        localStorage.removeItem('selected_currency_country');
      } catch (e) {}
      var defaultCurrency = getDefaultCurrencyForCountry(visitorCountry);
      if (CURRENCY_INFO[defaultCurrency]) {
        currentCurrency = defaultCurrency;
      }
    } else if (savedCurrency && CURRENCY_INFO[savedCurrency]) {
      currentCurrency = savedCurrency;
    } else if (visitorCountry) {
      var defaultCurrency2 = getDefaultCurrencyForCountry(visitorCountry);
      if (CURRENCY_INFO[defaultCurrency2]) {
        currentCurrency = defaultCurrency2;
      }
    }
    if (visitorCountry) {
      try { localStorage.setItem('selected_currency_country', visitorCountry); } catch (e) {}
    }
  }

  function initDropdown() {
    var btn = document.querySelector('.currency-selector__trigger');
    var dropdown = document.querySelector('.currency-selector__dropdown');
    if (!btn || !dropdown) return;

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var isOpen = !dropdown.hasAttribute('hidden');
      if (isOpen) {
        dropdown.setAttribute('hidden', '');
        btn.setAttribute('aria-expanded', 'false');
      } else {
        dropdown.removeAttribute('hidden');
        btn.setAttribute('aria-expanded', 'true');
      }
    });

    document.addEventListener('click', function (e) {
      if (!e.target.closest('.currency-selector')) {
        dropdown.setAttribute('hidden', '');
        btn.setAttribute('aria-expanded', 'false');
      }
    });

    document.querySelectorAll('.currency-selector__option').forEach(function (opt) {
      opt.addEventListener('click', function (e) {
        e.preventDefault();
        setCurrency(opt.dataset.currency);
        dropdown.setAttribute('hidden', '');
        btn.setAttribute('aria-expanded', 'false');
      });
    });
  }

  function init() {
    detectCurrency();
    updateTrigger();
    updateOptions();
    initDropdown();
    convertAllPrices();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window._currencyConverter = {
    convertAllPrices: convertAllPrices,
    setCurrency: setCurrency,
    getCurrentCurrency: function() { return currentCurrency; },
    formatFromINR: formatFromINR,
    RATES_PER_INR: RATES_PER_INR,
    CURRENCY_INFO: CURRENCY_INFO
  };
})();
